export default "__VITE_ASSET__Cc03sugp__"